import { createBrowserHistory } from "history"
import { routerMiddleware as createRouterMiddleware } from "connected-react-router"
import { configureStore, ThunkAction } from "@reduxjs/toolkit"
import "../utility/common/setupYupCustomValidations"
import createRootReducer from "./rootReducer"
import { queryApi, queryApiV1 } from "../api/api"
import { Action } from "redux"
import { isDevelopment } from "../utility/common/isDevelopment"
import { createLogger } from "redux-logger"
import { persistDialogDraftsMiddleware } from "./drafts/middleware"

export const history = createBrowserHistory({
    basename: process.env.PUBLIC_URL + "/"
})

const isReduxLoggerEnabled =
    process.env.REACT_APP_REDUX_LOGGER_ENABLED !== undefined
        ? process.env.REACT_APP_REDUX_LOGGER_ENABLED === "true"
        : true

const routerMiddleware = createRouterMiddleware(history)
const middlewares = [routerMiddleware, queryApi.middleware, queryApiV1.middleware, persistDialogDraftsMiddleware]

if (isReduxLoggerEnabled && isDevelopment) {
    const logger = createLogger({
        collapsed: true,
        duration: true,
        timestamp: true
    })

    middlewares.push(logger)
}

const store = configureStore({
    reducer: createRootReducer(history),
    middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false }).concat(middlewares),
    devTools: isDevelopment ? { maxAge: 50 } : false
})

export type Store = typeof store
export type AppState = ReturnType<typeof store.getState>
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>

export type AppDispatch = typeof store.dispatch

export default store
